var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74.355,
    height: 77.23,
    viewBox: "0 0 74.355 77.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 74.355,
    height: 77.23,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M18.762,3.217A10.992,10.992,0,0,0,0,10.99V53.75a10.99,10.99,0,1,0,21.979,0V10.99a10.956,10.956,0,0,0-3.217-7.773M16.022,53.75a5.037,5.037,0,1,1-10.074,0V10.99a5.037,5.037,0,1,1,10.074,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M26.188,0V64.74h10.99A10.99,10.99,0,0,0,48.167,53.75V10.99A10.989,10.989,0,0,0,37.178,0Zm10.99,58.783H32.145V5.949h5.033a5.033,5.033,0,0,1,5.033,5.033V53.75a5.033,5.033,0,0,1-5.033,5.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M52.376,0V64.74h10.99A10.99,10.99,0,0,0,74.355,53.75V10.99A10.989,10.989,0,0,0,63.366,0Zm10.99,58.783H58.333V5.949h5.033A5.033,5.033,0,0,1,68.4,10.982V53.75a5.033,5.033,0,0,1-5.033,5.033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M8.484,77.141,7.213,75.32a2.332,2.332,0,0,1-.24.009h-1.4v1.812H4.414V70.922H6.973a3.451,3.451,0,0,1,1.408.266,2.048,2.048,0,0,1,.92.765,2.138,2.138,0,0,1,.32,1.181,2.11,2.11,0,0,1-.342,1.209A2.037,2.037,0,0,1,8.3,75.1l1.43,2.043Zm-.418-4.922A1.777,1.777,0,0,0,6.92,71.9H5.569v2.479H6.92a1.759,1.759,0,0,0,1.146-.324,1.128,1.128,0,0,0,.391-.92,1.116,1.116,0,0,0-.391-.915"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M18.239,76.173v.968H13.574V70.922h4.541v.969H14.729v1.617h3v.95h-3v1.715Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M26.16,71.188a2.046,2.046,0,0,1,.92.764,2.334,2.334,0,0,1,0,2.359,2.037,2.037,0,0,1-.92.769,3.454,3.454,0,0,1-1.408.266h-1.4v1.795H22.193v-6.22h2.559a3.437,3.437,0,0,1,1.408.267m-.315,2.861a1.267,1.267,0,0,0,0-1.831A1.777,1.777,0,0,0,24.7,71.9H23.348v2.47H24.7a1.777,1.777,0,0,0,1.146-.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M31.887,76.506a2.819,2.819,0,0,1-.72-2.075V70.922h1.155v3.465q0,1.83,1.582,1.83t1.572-1.83V70.922h1.138v3.509a2.833,2.833,0,0,1-.715,2.075,3.141,3.141,0,0,1-4.012,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M46.12,74.471a1.573,1.573,0,0,1,.3.982A1.437,1.437,0,0,1,45.8,76.7a3.125,3.125,0,0,1-1.812.44H40.9v-6.22H43.81a2.858,2.858,0,0,1,1.7.432,1.381,1.381,0,0,1,.6,1.185,1.561,1.561,0,0,1-.213.818,1.464,1.464,0,0,1-.587.551,1.639,1.639,0,0,1,.818.564m-4.069-2.644v1.715h1.634a1.664,1.664,0,0,0,.929-.217.718.718,0,0,0,.324-.636.726.726,0,0,0-.324-.644,1.663,1.663,0,0,0-.929-.218Zm3.207,3.51q0-.9-1.342-.9H42.051v1.795h1.865q1.343,0,1.342-.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M50.323,70.922h1.155v5.242H54.73v.977H50.323Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 1.155,
    height: 6.219,
    transform: "translate(58.311 70.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M64.987,76.817a3.045,3.045,0,0,1-1.19-1.141,3.331,3.331,0,0,1,0-3.288A3.074,3.074,0,0,1,65,71.246a3.5,3.5,0,0,1,1.7-.413,3.558,3.558,0,0,1,1.4.266,2.849,2.849,0,0,1,1.066.773l-.746.7a2.175,2.175,0,0,0-1.661-.729,2.321,2.321,0,0,0-1.146.28,2.01,2.01,0,0,0-.791.777,2.377,2.377,0,0,0,0,2.257,2.013,2.013,0,0,0,.791.778,2.332,2.332,0,0,0,1.146.279,2.163,2.163,0,0,0,1.661-.737l.746.711a2.847,2.847,0,0,1-1.07.773,3.6,3.6,0,0,1-1.4.266,3.511,3.511,0,0,1-1.7-.413"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/brand.73d09339cb2739efbb6d14023ef84e45.svg";
export { ForwardRef as ReactComponent };